import { Checkbox } from '@app/formik';
import { Link } from '@mui/material';
import React from 'react';
import { Trans } from 'react-i18next';

import { resolvedTenantConfig } from '@app/tenant';

interface TermsAndMessageConsentCheckboxesProps {
  termsLabel: string;
  messageConsentLabel: string;
  termsName?: string;
  messageConsentName?: string;
  termsRequired?: boolean;
  messageConsentRequired?: boolean;
}

export const TermsAndMessageConsentCheckboxes: React.FC<TermsAndMessageConsentCheckboxesProps> = ({
  termsLabel,
  messageConsentLabel,
  termsName = 'terms',
  messageConsentName = 'messageConsent',
  termsRequired = true,
  messageConsentRequired = false,
}) => {
  return (
    <>
      <Checkbox
        label={
          <Trans
            i18nKey={termsLabel}
            components={{
              terms: <Link href={resolvedTenantConfig.urls.terms} target="_blank" />,
              policy: <Link href={resolvedTenantConfig.urls.privacy} target="_blank" />,
            }}
          />
        }
        name={termsName}
        required={termsRequired}
      />

      <Checkbox label={messageConsentLabel} name={messageConsentName} required={messageConsentRequired} />
    </>
  );
};
